import { Input } from '@/components/ui/input';
import { cn, uniqueId } from '@/lib/utils';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Field, FieldError, FieldLabel } from '@/components/ui/field';
import { type Orientation } from '@/components/form/form';

type InputProps = React.ComponentProps<typeof Input>;

type InputFieldProps = {
  name: string;
  label?: string;
  className?: string;
  orientation?: Orientation;
  inputClass?: string;
} & InputProps;

export function InputField({ label, className, orientation, inputClass, ...props }: InputFieldProps) {
  if (props?.type === 'date') {
    inputClass = cn(inputClass, 'w-36');
  }
  const { control } = useFormContext();
  const id = props?.id ?? uniqueId('input-field');
  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState }) => (
        <div className={cn('field-wrap', orientation, className)}>
          <Field data-invalid={fieldState.invalid} orientation={orientation}>
            {label && (
              <FieldLabel className="whitespace-nowrap" htmlFor={id}>
                {label}
              </FieldLabel>
            )}
            <Input className={inputClass} {...props} id={id} {...field} />
          </Field>
          {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
        </div>
      )}
    />
  );
}
